// 交易所公告详情
export const GETNOTICEDETAIL = 'get-notice-detail'
